import { ClockTypeId as ClockTypeId$1, make as make$1, clockTag } from '../../internal/clock.esm.js';
import { sleep as sleep$1, currentTimeMillis as currentTimeMillis$1, currentTimeNanos as currentTimeNanos$1, clockWith as clockWith$1 } from '../../internal/defaultServices.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const ClockTypeId = ClockTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * Represents a time-based clock which provides functionality related to time
 * and scheduling.
 *
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const make = make$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const sleep = sleep$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const currentTimeMillis = currentTimeMillis$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const currentTimeNanos = currentTimeNanos$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const clockWith = clockWith$1;

/**
 * @since 2.0.0
 * @category context
 */
const Clock = clockTag;

export { Clock, ClockTypeId, clockWith, currentTimeMillis, currentTimeNanos, make, sleep };
